import { memo } from 'react'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { AvatarVoiceTab } from 'store/types/aiAvatar'
import * as Styled from './styled'

const TABS = [
  { key: AvatarVoiceTab.LIBRARY, label: T.VOICE_LIBRARY_LABEL },
  { key: AvatarVoiceTab.CLONE, label: T.VOICE_CLONE_LABEL }
]

interface IProps {
  activeTab: AvatarVoiceTab
  onTabChange: (tab: AvatarVoiceTab) => void
}

const VoiceTabs: React.FC<IProps> = ({ activeTab, onTabChange }) => (
  <Styled.TabsContainer>
    {TABS.map(({ key, label }) => {
      const isActive = key === activeTab
      return (
        <Styled.TabButton
          key={key}
          type="button"
          $isActive={isActive}
          onClick={() => onTabChange(key)}
          data-testid={`voice-tab-${key}`}
        >
          <Text
            type={isActive ? 'h3' : 'h4'}
            color={isActive ? 'primaryDark' : 'secondarySemiDark'}
            ellipsis
          >
            {translate(label)}
          </Text>
        </Styled.TabButton>
      )
    })}
  </Styled.TabsContainer>
)

export default memo(VoiceTabs)
